// import { STATUS_CODES } from "http";
/**
 * Error Codes for common exception (to handle on client)
 */
export enum ErrorCodes {
  Unknown = 0,
  System = 100,

  // HTTP-mapped errors
  ServiceClientException = 400,
  ServiceUnauthorized = 401,
  ServiceActionForbidden = 403,
  ServiceNotFound = 404,
  ServiceDeserializeError = 415,
  ServiceVersionUnsupported = 501,
  ServiceInternalError = 500,
  ServiceConnectionException = 503,

  // Custom application errors
  UnauthorizedRequest = 900,          // User not logged in
  UnauthorizedSessionRequest = 901,   // Session invalid

  TenantNotFound = 1000,
  TenantCreationError = 1001,
  DefaultAccountNotFound = 1002,
  Office365AccountNotFound = 1003,
}


export enum ErrorTypes {
  Undefined,
  Bug,
  ServiceConnection,
  DeletedAccount,
  ServiceError,
}
